import script from "./basic_layout.vue?vue&type=script&setup=true&lang=js"
export * from "./basic_layout.vue?vue&type=script&setup=true&lang=js"

import "./basic_layout.vue?vue&type=style&index=0&id=122a1be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122a1be2"]])

export default __exports__